import Utils from "../Utils";
import axios from "axios";
import Cookie from "js-cookie";

export default (function() {
  function isRedirectPage() {
    return document.body.classList.contains('coupons') && document.body.classList.contains('clickout');
  }

  function triggerTrackingUserEvent() {
    const event = new CustomEvent('tracking_user_set');
    document.dispatchEvent(event);
  }

  function setUserTracking() {
    if (isRedirectPage()) {
      return;
    }

    const subIdTracking = Cookie.get("subIdTracking");
    if (subIdTracking) {
      triggerTrackingUserEvent();
      return;
    }

    const urlWithoutQueryString = window.location.href.split('?')[0];
    let allVars: Record<string, string> = {};

    if (window.location.href.indexOf('?') !== -1 && urlWithoutQueryString.indexOf('search') === -1) {
      Object.assign(allVars, Utils.getUrlVars());
    }

    let referrer = document.referrer;

    if (referrer === '' || referrer === "undefined") {
      referrer = 'unknown';
    }

    allVars.referrer = referrer;

    axios
      .post(window.rootDir + '/tracking/set', {query_string_params: allVars})
      .then(function() {
        triggerTrackingUserEvent();
      })
      .catch(err => {
        console.error(err.response);
      });
  }


  return {
    run: setUserTracking
  };
})();
